(function () {

  'use strict';

  function pxDestinationProfile() {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowFormModel: '=',
        destinationType: '=',
        logoPath: '=',
        placeholder: '=',
        filter: '=',
        selectId: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/destination/profile/destinationProfile.template.html',
      link: function (scope, element, attrs) {

        /**
         * Called after the "Create destination profile" dialog was closed with the "Create" button.
         *
         * @param {DestinationProfileModel} destinationProfile The newly created destination profile.
         */
        scope.closeDestinationProfileToWorkflow = function (destinationProfile) {
          if (destinationProfile) {
            scope.setDestinationProfile(destinationProfile, `SEND_TO_${destinationProfile.info.type.toUpperCase()}`);
          }
          scope.dialog = null;
        };

        /**
         * Called after a destination profile was selected from the profile list OR after a new destination profile was created.
         * @param {DestinationProfileModel} destinationProfile The selected or newly created destination profile.
         * @param {'SEND_TO_SHAREPOINT'|'SEND_TO_ONEDRIVE'|'SEND_TO_CONNECTOR'} DESTINATION
         */
        scope.setDestinationProfile = function (destinationProfile, DESTINATION) {
          // HACK - We need this hack when this method is called from closeDestinationProfileToWorkflow().
          // That method computes the value for the DESTINATION parameter using the created profile's internal destination name. For
          // OneDrive, it's 'OneDriveForBusiness' so the computed string value for the DESTINATION parameter would be incorrect
          // because the createWorkflow directive uses the "SEND_TO_ONEDRIVE" identifier for handling the OneDrive destination profiles.
          if (DESTINATION === 'SEND_TO_ONEDRIVEFORBUSINESS') {
            DESTINATION = 'SEND_TO_ONEDRIVE';
          }
          scope.workflowFormModel.destination = DESTINATION;
          scope.workflowFormModel[DESTINATION].destinationProfile = destinationProfile.info._links.self.href;
          scope.workflowFormModel[DESTINATION].destinationProfileData = destinationProfile.info;
        };

        scope.changeDestinationProfile = function (event, DESTINATION) {
          scope.workflowFormModel[DESTINATION].destinationProfile = null;
          scope.workflowFormModel[DESTINATION].destinationProfileData = null;
        };

        scope.openDialog = function (event, dialog) {
          event.preventDefault();
          scope.closeDialog();
          switch (dialog) {
            case 'CREATE_DESTINATION_PROFILE':
              createDestinationProfile(dialog);
              break;
          }
        };

        scope.closeDialog = function () {
          scope.context = null;
          scope.dialog = null;
        };

        function createDestinationProfile(dialog) {
          scope.context = {
            behavior: 'CREATE_IN_WORKFLOW',
            name: 'CreateDestinationProfile'
          };
          scope.dialog = dialog;
        }

      }
    };
  }

  pxDestinationProfile.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxDestinationProfile', pxDestinationProfile);

})();
